import {NgModel} from './ngModel';

export const Industry = NgModel.extend({
    _name: 'Industry',
});
